import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {BudgetModel} from '@cas-hub/acabim-financial-client';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ConfirmationService, MessageService} from 'primeng/api';
import {LtmsService} from '../../../../_services/ltms.service';
import {CbiService, GenericOption, GenericOptionGroup} from '@cas-hub/acabim-common-client';
import {LTMSBudgetParent, LTMSProjectDatatableItem} from '../../../../_models/ltms.model';

@Component({
    selector: 'acabim-admin-edit-details',
    templateUrl: './edit-details.component.html',
    styleUrls: ['./edit-details.component.scss'],
    providers: [MessageService]
})
export class EditDetailsComponent implements OnInit {

    _availableYears: { name: number }[] = [];   isLoading = false;
    _detailData?: BudgetModel;
    cbiOptionsGrouped: GenericOptionGroup[] = [];
    done = false;
    mode = 'add';
    ltmItem: LTMSProjectDatatableItem | null = null;
    yearOptions: GenericOption[] = [];
    currentYear: number = (new Date()).getFullYear();
    editDetail = new FormGroup({
        amount: new FormControl(null, Validators.required),
        cbiClass: new FormControl(null),
        year: new FormControl(null, Validators.required)
    });

    @Input() itemId?: string;
    @Input() type?: 'budget' | 'expenditure';
    @Input() set detailData(value: LTMSBudgetParent) {
        console.dir(value);
        this.ltmItem = value.parent;
        this._detailData = value.model;
        if (value.model) {
            this.mode = 'edit';
        }
        this._availableYears = [];
        for (let i = value.range.before; i > 0; i--) {
            this.yearOptions.push(this.handleYear(this.currentYear - i));
        }
        // this.yearOptions.push(this.handleYear(this.currentYear));
        for (let i = 0; i <= value.range.after; i++) {
            this.yearOptions.push(this.handleYear(this.currentYear + i));
        }
        this.cbiService.getGrouped().subscribe(cbiGroup =>
            {
                this.cbiOptionsGrouped = this.cbiService.optionCbiGroupedClasses(cbiGroup);
                this.editDetail.get('year')?.setValue(this.currentYear);
                if (value.model && this.editDetail) {
                    this.editDetail.get('amount')?.setValue(value.model.amount);
                    this.editDetail.get('amount')?.updateValueAndValidity();
                    // const currentYear = this._availableYears.filter(x => x.name === value.model.year)[0];
                    this.editDetail.get('year')?.setValue(value.model.year);
                    this.editDetail.get('year')?.updateValueAndValidity();
                }
            }
        );
    }

    @Output() closeModal = new EventEmitter<string>();

    constructor(
        private readonly cbiService: CbiService,
        private readonly messageService: MessageService,
        private readonly ltmsService: LtmsService,
        private confirmationService: ConfirmationService
    ) {}

    ngOnInit(): void {}

    addBudget(): void {
        if (this.editDetail.valid) {
            if (this._detailData) {
                this.isLoading = true;
                if (this.type === 'budget' && this.itemId && this.editDetail) {
                    this.ltmsService.updateBudgetsForItem(this.itemId, {
                        amount: this.editDetail.get('amount')?.value,
                        year: this.editDetail.get('year')?.value
                    }).subscribe(data => {
                        this.isLoading = false;
                        this.done = true;
                    }, error => {
                        this.isLoading = false;
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Cannot update ' + this.type
                        });
                    });
                } else {
                    if (this.itemId && this.editDetail) {
                        this.ltmsService.updateExpenditureForItem(this.itemId, {
                            amount: this.editDetail.get('amount')?.value,
                            year: this.editDetail.get('year')?.value
                        }).subscribe(data => {
                            this.isLoading = false;
                            this.done = true;
                        }, error => {
                            this.isLoading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: 'Cannot update ' + this.type
                            });
                        });
                    }
                }
            } else {
                this.isLoading = true;
                if (this.type === 'budget' && this.itemId && this.editDetail) {
                    this.ltmsService.addBudgetsForItem(this.itemId, {
                        amount: this.editDetail.get('amount')?.value,
                        year: this.editDetail.get('year')?.value
                    }).subscribe(data => {
                        this.isLoading = false;
                        this.done = true;
                    }, error => {
                        this.isLoading = false;
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Cannot add ' + this.type
                        });
                    });
                } else {
                    if (this.itemId) {
                        this.ltmsService.addExpenditureForItem(this.itemId, {
                            amount: this.editDetail.get('amount')?.value,
                            year: this.editDetail.get('year')?.value
                        }).subscribe(data => {
                            this.isLoading = false;
                            this.done = true;
                        }, error => {
                            this.isLoading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: 'Cannot add ' + this.type
                            });
                        });
                    }
                }
            }
        } else {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Please fill the form'
            });
        }
    }

    delete(): void {
        this.confirmationService.confirm({
            message: 'Are you sure that you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteCurrentBudget();
            },
            reject: () => {
            }
        });
    }

    close(): void {
        this.closeModal.emit('close');
    }

    completedSubmission() {
        this.closeModal.emit(this.type);
    }


    deleteCurrentBudget() {
        if (this.itemId) {
            if (this.type === 'budget' && this._detailData?.year) {
                this.ltmsService.removeBudgetsForItem(this.itemId, this._detailData?.year).subscribe(data => {
                    this.closeModal.emit('budget');
                }, error => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Cannot remove budget'
                    });
                });
            } else if (this.type === 'expenditure' && this._detailData?.year) {
                this.ltmsService.removeExpenditureForItem(this.itemId, this._detailData?.year).subscribe(data => {
                    this.closeModal.emit('expenditure');
                }, error => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Cannot remove expenditure'
                    });
                });
            }
        }
    }

    private handleYear(year: number): GenericOption {
        const newYear = year.toString();
        return {
            label: newYear,
            value: year
        };
    }
}
